import { Avatar, Box, Fab, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useAlertMessage } from '../../providers/alert-provider';
import { useApi } from '../../../api';
import AddIcon from '@mui/icons-material/Add';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { SearchBar, EmptyState, Breadcrumbs } from '../shared';

export const Locations: React.FC = () => {
    const alert = useAlertMessage();
    const navigate = useNavigate();
    const { Api } = useApi();
    const [locations, setLocations] = useState<StorageLocation[]>([]);

    const theme = useTheme();

    useEffect(() => {
        Api.Location.getLocaions()
            .then(({ data }) => {
                setLocations(data);
            });
    }, []);

    const handleQrCodeScan = (code: string) => {
        Api.Search.searchByQrCode(code)
            .then(({ data }) => {
                // Navigate directly to the box
                if (data.boxId) {
                    navigate(`${data.locationId}/box/${data.boxId}`);
                }
            })
            .catch((_error) => {
                alert.addMessage(`No box found with code: ${code}`);
            });
    };

    return (
        <React.Fragment>
            <Box
                sx={{
                    margin: 2,
                    mb: 2
                }}>
                <Breadcrumbs items={[]} />
            </Box>
            <Box
                sx={{
                    position: "relative",
                    margin: 2
                }}>
                <SearchBar
                    placeholder="Search all boxes and items..."
                    onQrCodeScan={handleQrCodeScan}
                />
            </Box>
            <Box sx={{
                position: "relative"
            }}>
                <Box
                    sx={{
                        position: "absolute",
                        right: theme.spacing(1),
                        top: theme.spacing(1),
                        zIndex: 1
                    }}>
                    <Fab color="primary" title="Add a Location" aria-label="add" component={Link} to={`add`}>
                        <AddIcon />
                    </Fab>
                </Box>
                <Paper>
                    <Box sx={{
                        position: "relative"
                    }}>
                        <Box
                            sx={{
                                margin: 1,
                                textAlign: "center",
                                position: "relative",
                                pb: 2,

                                // Extra horizontal padding on mobile to avoid FAB overlap
                                px: { xs: 8, sm: 2 },

                                // Slightly more top padding on mobile
                                pt: { xs: 1.5, sm: 1 }
                            }}>
                            <Typography variant='h4' sx={{ 
                                fontSize: { xs: '1.75rem', sm: '2.125rem' } // Slightly smaller on mobile
                            }}>
                                Your Locations
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{
                        margin: 2
                    }}>
                        {locations.length === 0 ? (
                            <EmptyState
                                icon={WarehouseIcon}
                                title="No locations yet"
                                message="Create your first storage location to start organizing your items. Locations can be rooms, buildings, or any physical space where you store boxes."
                                actionLabel="Add Location"
                                onAction={() => navigate('add')}
                            />
                        ) : (
                            <List>
                                {
                                    locations.map(location =>
                                        <ListItem 
                                            key={location.locationId}
                                        >
                                            <ListItemButton component={Link} to={`${location.locationId}`}>
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        <WarehouseIcon />
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText primary={location.name} />
                                            </ListItemButton>
                                        </ListItem>
                                    )
                                }
                            </List>
                        )}
                    </Box>
                </Paper>
            </Box>
        </React.Fragment>
    );
}